<template>
  <div class="columns is-mobile">
    <div
      class="column is-full-mobile is-two-thirds-tablet is-offset-one-third-tablet is-half-desktop is-offset-half-desktop is-one-third-widescreen is-offset-two-thirds-widescreen is-one-quarter-fullhd is-offset-three-quarters-fullhd"
    >
      <h1 class="title">{{ $t("page.reset_password") }}</h1>
      <h2 class="subtitle">{{ $t("message.fill_form_below") }}</h2>
      <form
        class="form has-background-light"
        action
        @submit.prevent="onSubmitCode"
        data-vv-scope="code"
      >
        <field-input
          :value.sync="email"
          name="email"
          :label="`${$t('form.email')}:`"
          :vvas="$t('form.email')"
          type="email"
          required
          scope="code"
          autocomplete="new-Email"
          :disabled="codeRequired"
        />

        <div class="control">
          <button
            tyle="submit"
            class="button is-primary"
            :class="{ 'is-loading': formLoading }"
            v-if="!codeRequired"
          >
            <span>{{ $t("form.next") }}</span>
          </button>
        </div>
      </form>

      <input type="text" ref="password" :value="password" hidden />

      <form
        class="form has-background-light m-t-5"
        action
        @submit.prevent="onSubmit"
        data-vv-scope="reset"
        v-if="codeRequired"
      >
        <button
          @click="resend"
          type="button"
          class="button is-link is_blank is-small is-pulled-right"
          :class="{ 'is-loading': resending }"
        >{{ $t("form.resend") }}</button>
        <p class="has-text-dark m-b-5">{{ $t("message.check_email_for_code") }}</p>
        <field-input
          :value.sync="code"
          name="code"
          :label="`${$t('form.code')}:`"
          :vvas="$t('form.code')"
          type="number"
          required
          scope="reset"
          autocomplete="new-code"
        />
        <field-input
          :value.sync="password"
          name="password"
          :label="`${$t('form.password')}:`"
          :vvas="$t('form.password')"
          type="password"
          required
          scope="reset"
          autocomplete="new-password"
        />
        <field-input
          :value.sync="password_confirmation"
          name="password_confirmation"
          :label="`${$t('form.password_confirmation')}:`"
          :vvas="$t('form.password_confirmation')"
          type="password"
          required
          scope="reset"
          autocomplete="new-password-confirmation"
        />
        <div class="control">
          <button tyle="submit" class="button is-primary" :class="{ 'is-loading': formLoading }">
            <span>{{ $t("form.submit") }}</span>
          </button>
        </div>
      </form>
      <div class="m-t-5">
        <nuxt-link
          :to="localePath('login')"
          class="is-text has-text-white"
          style="text-decoration: underline;"
        >{{ $t("page.login") }}</nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  auth: false,

  layout: "auth",

  data() {
    return {
      email: "",
      code: "",
      password: "",
      password_confirmation: "",
      codeRequired: false,
      formLoading: false,
      resending: false
    };
  },

  methods: {
    async resend() {
      this.resending = true;
      try {
        await this.sendEmailCode();
      } catch (e) {}
      this.resending = false;
    },

    async onSubmitCode() {
      const validation = await this.$validator.validateAll("code");
      if (!validation) return;

      this.formLoading = true;

      try {
        await this.sendEmailCode();
        this.codeRequired = true;
      } catch (e) {
        console.log(e);
      }

      this.formLoading = false;
    },

    async sendEmailCode() {
      const { email } = this;

      try {
        const { data } = await this.$api.resetPasswordCode({
          email
        });
        return Promise.resolve(data);
      } catch (e) {
        console.log(e);
        console.log(e.response);
        console.log(e.response.data);
        this.handleFormError(e.response.data, "code");
        return Promise.reject(e);
      }
    },

    async onSubmit() {
      const validation = await this.$validator.validateAll("reset");
      if (!validation) return;

      const { code, password, password_confirmation } = this;

      this.formLoading = true;

      try {
        await this.$api.resetPassword({
          code,
          password,
          password_confirmation
        });

        this.$router.push(this.localePath("login"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data, "reset");
      }
      this.formLoading = false;
    }
  }
};
</script>


// <style lang="scss" scoped>
.form {
  border-radius: 5px;
  padding: 15px 20px;
}
// .column {
//   border-radius: ;
// }
//
</style>



// WEBPACK FOOTER //
// resources/nuxt/pages/reset-password.vue